import Vue from 'vue'
import actionPickerVue from './ActionPicker.vue'

const defaultOptions = {
  confirmText: '',
  cancelText: '',
  titleText: '',
  selectedIndex: 0,
  forceUpdate: false, // 多个列表时是否共用同一个index记录
  actions: [] // { name: 文本 }
}

let currentMsg, instance
const instanceObj = {}

const msgQueue = []
const ActionPickerConstructor = Vue.extend(actionPickerVue)

const defaultCallback = data => {
  if (currentMsg.resolve && currentMsg.reject) {
    if (data.action !== 'cancel') {
      currentMsg.resolve(data)
    } else {
      currentMsg.reject(data)
    }
  }
}

const initInstance = () => {
  const newInstance = new ActionPickerConstructor({
    el: document.createElement('div')
  })

  newInstance.callback = defaultCallback
  return newInstance
}

const showNextMsg = (id) => {
  // 同个页面有多个ActionPicker组件时，要通options.id新建并区分不同的实列
  if (id) {
    if (!instanceObj[id]) {
      instanceObj[id] = initInstance()
    }
    instance = instanceObj[id]
  } else {
    if (!instance) {
      instance = initInstance()
    }
  }

  if (!instance.value) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      const options = currentMsg.options
      for (const prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.value = true
      })
    }
  }
}

const ActionPicker = options => {
  return new Promise((resolve, reject) => {
    msgQueue.push({
      options: Object.assign({}, defaultOptions, options),
      callback: defaultCallback,
      resolve,
      reject
    })

    showNextMsg(options.id)
  })
}

function closeMask () {
  if (!instance) return
  instance.closeMask()
}
export default ActionPicker
export { ActionPicker, closeMask }
